import React, { useEffect, useState } from 'react';
import '../style/Hero.css';
import slide1 from '../images/DSC_73092.webp';
import slide2 from '../images/DSC_7376.webp';
import slide3 from '../images/unnamed-2.webp';

const slides = [slide1, slide2, slide3];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      
      <div className="hero__left">
        <div className="hero__text">
          <h1 className="hero__title">ПариМосква</h1>
          <p className="hero__subtitle">
            Настоящий ценитель не ест торт,<br /> а пробует его секреты на вкус
          </p>
          <button className="hero__btn" onClick={() => scrollToSection('About')}>
            Смотреть торты
          </button>
          <div
            className="hero__scroll"
            onClick={() => scrollToSection('About')}
            role="button"
            aria-label="Scroll down"
          />
        </div>
      </div>

      <div className="hero__right">
        <div
          className="hero__slider"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {slides.map((img, index) => (
            <img
              src={img}
              key={index}
              alt={`slide-${index}`}
              className="hero__slide"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}
